import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { isEmbedded, startHeightReporter } from "./lib/embed";
import { captureLanding } from "./lib/landing";
import "./index.css";

// Framed by /embed.js on another site: compact layout, and report our height to the parent.
if (isEmbedded()) {
  document.documentElement.setAttribute("data-embed", "");
  startHeightReporter();
}

// The URL parameters this visit landed with, before any navigation drops them.
captureLanding();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
